<script setup lang="ts">
import { useCart } from '@consumer/services/order'
import { checkout } from '@consumer/api'
import Cart from './CartMenu/Cart.vue'
import CartButton from './CartMenu/CartButton.vue'
import FlyOut from './FlyOut/FlyOut.vue'
import CartTitle from './CartMenu/CartTitle.vue'

const cart = useCart()
</script>

<template>
  <FlyOut id="cart-menu" variant="list">
    <template #trigger>
      <CartButton/>
    </template>

    <template #header>
      <CartTitle/>

      <GLink
        v-if="cart.count"
        class="link font-semibold py-2 -my-2"
        name="cart-menu-proceed-to-checkout"
        :href="checkout.checkout.path()"
        data-track-ga="cart-proceed-to-checkout"
      >Proceed to Checkout</GLink>
    </template>

    <template #content>
      <Cart/>
    </template>
  </FlyOut>
</template>
